import { UUID } from "@stellar/api-logic";
import { GUID } from "@faro-lotv/ielement-types";
import { useCallback } from "react";
import { runtimeConfig } from "@src/runtime-config";
import axios from "axios";

/** query parameters required for the post request to Orbis processing worker */
interface OrbisWorkerApiTriggerProps {
  /** UUID of the user interacting with Data Management */
  userId: UUID;

  /** Project Id of the associated project */
  projectId: GUID;
}

/** successfull response from worker */
export interface OrbisProcessingSuccessResponse {
   /** jobId created on the processing worker */
  jobId: string;
}

interface OrbisWorkerApi {
  /** Makes a POST to the httpTrigger route */
  processOrbisScan(elementId: string, authorizationCode: string): Promise<OrbisProcessingSuccessResponse>;
}

/** Axios instance to simplify calls to Orbis Worker API */
const axiosInstance = axios.create({
  baseURL: runtimeConfig.urls.orbisProcessingWorkerUrl,
});

/**
 * Hook that provides access to the OrbisWorkerClientApi.
 */
export function useOrbisWorkerApi(orbisWorkerApiParams: OrbisWorkerApiTriggerProps): OrbisWorkerApi {

  /** Wrapper function to make a post to the API and return the body */
  const processOrbisScan = useCallback(
    async (elementId: string, authorizationCode: string): Promise<OrbisProcessingSuccessResponse> => {
      const response = await axiosInstance.post("/httpTrigger", "",{
        params: {
          elementId: elementId,
          code: authorizationCode,
          projectId: orbisWorkerApiParams.projectId,
          userId: orbisWorkerApiParams.userId,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- request query parameter
          captureTree: true,
        },
      });
      return response.data;
    },
    [orbisWorkerApiParams]
  );

  return { processOrbisScan };
}

